module.exports = __webpack_public_path__ + "media/assets/images/flags/by-0fb1d86799899de5198477769aaa3fe9.svg";